import React from "react";
import styles from "./Contact.module.css";

const Contact = () => {
  return (
    <div className={styles.container}>
      <h1>Contato</h1>

      <p>
        Se você tiver dúvidas, sugestões ou quiser entrar em contato com o
        Fohattech, utilize as opções abaixo.
      </p>

      <div className={styles.box}>
        <h2>Email</h2>
        <p>fohattech@gmail.com</p>
      </div>

      <div className={styles.box}>
        <h2>Redes sociais</h2>
        <p>
          Instagram:{" "}
          <a
            href="https://www.instagram.com/fohattech/"
            target="_blank"
            rel="noreferrer"
          >
            @fohattech
          </a>
        </p>
      </div>

      <p className={styles.info}>
        Respondemos o mais rápido possível dentro do horário comercial.
      </p>
    </div>
  );
};

export default Contact;